import React, { useState } from 'react';
import { Switch } from "@material-ui/core"

const Plan = props => {
	const { selected, pricePlan, billingInterval } = props;
	const [isAnnualy, setIsAnnualy] = useState(!billingInterval ? true : billingInterval === 'ANNUAL');

	const onCycleChange = (e) => {
		setIsAnnualy(e.target.checked)
	}

	const getPrice = () => {
		const origPrice = isAnnualy ? pricePlan.pricing[selected] : pricePlan.pricing[selected] * 1.2;
		return (Math.round(origPrice * 100) / 100).toFixed(2);
	}
	const showContactUs = pricePlan.pricing[selected] === 'CONTACTUS';
	return (
		<div className='plan-modal'>
			<div className='card w-100 rounded-0 right-panel'>
				<div>
					<div className='d-flex header-wrapper'>
						<h3>Summary</h3>
						<div className='btn btn-sm btn-icon' id='kt_drawer_plan_close'>
							{/* <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' /> */}
						</div>
					</div>
					<div className='plan-details'>
						<span className='title-plan fs-4 fw-bold'>Plan</span>
						<span className='fs-5 monthly' style={{ textTransform: 'capitalize' }}>
							{selected} {pricePlan.monthlySessions} Sessions a month
						</span>
					</div>
					<div className='billing-wrapper'>
						<span className='title-plan fs-4 fw-bold'>Billing cycle</span>
						<div>
							<span className='fs-5 monthly'>Monthly</span>
							<Switch checked={isAnnualy} onChange={onCycleChange} />
							<span className='fs-5 monthly'>Annualy (save 20%)</span>
						</div>
					</div>
					{!showContactUs && (
						<div>
							<span className='title-plan fs-4 fw-bold'>Price</span>
							<span className='price-title fs-1 fw-bold'>
								<span className='fs-6 monthly'> {'$' + getPrice()} per month</span>
								{isAnnualy &&
									<div className='fs-6 monthly'> {'$' + new Intl.NumberFormat('en-US').format(getPrice() * 12)} per year</div>
								}
							</span>
						</div>
					)}
				</div>
				<div className='btn-wrapper'>
					<span className='monthly'>
						Need additional information? <a href='#/'
							onClick={() => window.open('mailto:contact@squadded.com')}>Learn more</a>
					</span>
				</div>
			</div>
		</div>
	);
};

export default Plan;
